import { combineReducers } from "redux";
import { userReducer } from "./user_reducer";
import { productsReducer } from "./products_reducer";
import { categoriesReducer } from "./categories_reducer";
import { contactsReducer } from "./contacts_reducer";
import { loadingReducer } from "./loading_reducer";
import { registerFormReducer } from "./register_form_reducer";
import { portalReducer } from "./portal_reducer";
import { loginFormReducer } from "./login_form_reducer";
import { profileFormReducer } from "./profile_form_reducer";
import { forgotFormReducer } from "./forgot_form_reducer";
import { passwordResetConfirmReducer } from "./password_reset_confirn_form_reducer";
import { setPasswordReducer } from "./set_password_reducer";
import { setEmailReducer } from "./set_email_reducer";
import { deleteMeReducer } from "./delete_me_reducer";
import { settingsReducer } from "./settings_reducer";
import { pathParamsReducer } from "./path_params_reducer";
import { menuCategoriesReducer } from "./menu_categories_reducer";
import { newsReducer } from "./news_reducer";
import { currNewsReducer } from "./curr_news_reducer";
import { currProductReducer } from "./curr_product_reducer";
import { saleNewPopularReducer} from "./sale_new_popular_reducer";
import { ordersReducer } from "./orders_reducer";
import { firmsReducer } from "./firms_reducer";
import { firmAddReducer } from "./firm_add_reducer";
import { cartReducer } from "./cart_reducer";
import { shippingsReducer } from "./shippings_reducer";
import { favReducer } from "./fav_reducer";
import { quickRegisterFormReducer } from "./quick_register_form_reducer";
import { findUserReducerForm } from "./find_user_reducer";
import { customerReducer } from "./customer_reducer";
import { currOrderReducer } from "./curr_order_reducer";
import { resendFormReducer } from "./resend_activation_reducer";
import { newOrderReducer } from "./new_order_reducer";


export const rootReducer = combineReducers({
  user: userReducer,
  products: productsReducer,
  categories: categoriesReducer,
  contacts: contactsReducer,
  loading: loadingReducer,
  registerForm: registerFormReducer,
  loginForm: loginFormReducer,
  portal: portalReducer,
  profileForm: profileFormReducer,
  forgotForm: forgotFormReducer,
  passwordResetForm: passwordResetConfirmReducer,
  setPasswordForm: setPasswordReducer,
  setEmailForm: setEmailReducer,
  deleteMeForm: deleteMeReducer,
  settings: settingsReducer,
  pathParams: pathParamsReducer,
  menuCategories: menuCategoriesReducer,
  news: newsReducer,
  currNews: currNewsReducer,
  currProduct: currProductReducer,
  saleNewPopular: saleNewPopularReducer,
  myOrders: ordersReducer,
  myFirms: firmsReducer,
  firmAdd: firmAddReducer,
  cart: cartReducer,
  shippings: shippingsReducer,
  fav: favReducer,
  quickRegisterForm: quickRegisterFormReducer,
  findUserForm: findUserReducerForm,
  customer: customerReducer,
  currOrder: currOrderReducer,
  resendForm: resendFormReducer,
  newOrderProducts: newOrderReducer
});
